
















import Inspector from '@/models/Inspector.ts'
import Vue from 'vue'

export default Vue.extend({
  name: 'SelectUsers',
  props: {
    selectedInspectors: { type: Array },
    registeredInspectors: { type: Array }
  },
  data: () => {
    return {
      fullName: 'I',
      inspector: new Inspector('', '', '')
    }
  },
  computed: {
    enhancedInspectors () {
      console.log('DEBUG INSPECTORS')
      return this.registeredInspectors.map(inspector => {
        return {
          ...(inspector as Inspector),
          selected: this.selectedInspectors.filter(insp =>
            (insp as Inspector).firstName === (inspector as Inspector).firstName &&
            (insp as Inspector).lastName === (inspector as Inspector).lastName
          ).length > 0
        }
      })
    }
  },
  methods: {
    createUser () {
      return new FileReader()
    },

    clickInspector (inspector: Inspector) {
      console.clear()
      let found = false;
      (this.selectedInspectors as Array<Inspector>).forEach((registeredInspector: Inspector) => {
        if (inspector.lastName === registeredInspector.lastName && inspector.firstName === registeredInspector.firstName) {
          found = true
        }
      })
      console.log('COUNT', found, this.selectedInspectors.length)
      if (!found && this.selectedInspectors.length > 1) {
        console.log('TRACK', 'depop ancien')

        this.$emit('unselect-inspector', this.selectedInspectors[0])
        // this.$emit('unselectInspector', this.selectedInspectors[0])
      }
      if (found) {
        console.log('TRACK', 'supprime')
        this.$emit('unselect-inspector', inspector)
        this.enhancedInspectors.forEach((currentInspector: any) => {
          if (currentInspector.firstName === inspector.firstName &&
          currentInspector.lastName === inspector.lastName) {
            currentInspector.selected = false
          }
        })
      } else if (!found) {
        console.log('TRACK', 'ajoute')
        this.$emit('select-inspector', inspector)
        this.enhancedInspectors.forEach((currentInspector: any) => {
          if (currentInspector.firstName === inspector.firstName &&
          currentInspector.lastName === inspector.lastName) {
            currentInspector.selected = true
          }
        })
      }
    }
  }
})

